import './index.css'
import * as React from 'react'
type Props = {
  type?: 'default' | 'small' | 'smaller' | 'smallest'
  style?: Record<string, any>
}

/**
 * A vertical spacer component that adds consistent vertical spacing between elements
 * @param type - The size of the spacer ('default', 'small', 'smaller', 'smallest', defaults to 'default')
 * @param style - Optional inline styles to apply
 * @returns A div element with vertical spacing
 */
// SLAM-1943: Defaults moved to params because React 19 ignores defaultProps on function components.
const VerticalSpacer = ({
  type = 'default',
  style,
}: Props): React.ReactElement<'div'> => (
  <div className={`vertical-spacer--${type}`} style={style} />
)

export default VerticalSpacer
